import { render, staticRenderFns } from "./RelatedDeliverablesSocialMedia.vue?vue&type=template&id=67e560e2&"
import script from "./RelatedDeliverablesSocialMedia.vue?vue&type=script&lang=js&"
export * from "./RelatedDeliverablesSocialMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports